
export default {
    data() {
        return {
            //set "true" to show the confirmation dialog before deleting
            confirm: false,
            //store the id of the user for deleting
            selected_user: '',
            //set true if we are deleting a bank
            bank: false
        }
    },
    methods: {

        //request new password reset link
        resetPassword(id) {
            window.axios
                .post("/user/password-reset?id=" + id)
                .then(({ data }) => {
                    Event.$emit("message", [data.message]);
                })
        },

        //block/unblock the user
        blockUser(id) {
            window.axios
                .post("/lmt/agent/block?id=" + id)
                .then(({ data }) => {
                    Event.$emit("message", [data.message]);
                    this.loadData();
                })
        },

        //delete the selected user
        deleteUser() {
            window.axios
                .post("/lmt/user/delete?id=" + this.selected_user)
                .then(({ data }) => {
                    Event.$emit("message", [data.message]);

                    this.confirm = false;
                    //if we are deleting a bank redirect to all banks since we are deleting from details page
                    if (this.bank) {
                        this.$router.push('/owner/bank');
                    } else {
                        this.loadData();
                    }
                })
        },

        //requst confirmation from the user before deleting
        confirmDelete(id, is_bank = false) {
            //open the popup
            this.confirm = true;
            // select the user for deleting
            this.selected_user = id;
            //set if we are deleting bank
            this.bank = is_bank;
        },

        //user has confirmed deleting
        onConfirm() {
            this.deleteUser();
        },

        //user has canceled the delete action
        onCancel() {
            this.confirm = false;
        },
    }
}